
import React, { useState } from "react";
import { Link } from "react-router-dom";
import SRList from "../component/List";
import AkkhorLayout from "../layout/akkhor";
import { Modal } from "react-bootstrap";
import SearchBoxModal from "../component/SearchBoxModal";
import FormUsersFast from "./FormUsersFast";

export default function NhanSuNghiNhieu() {
    const [params, setParam] = useState();
    const [keyword, setKeyword] = useState('');
    const [filterShow, setFilterShow] = useState(false)
    const [dataSelect, setDataSelect] = useState(null)
    const [modalShow, setModalShow] = useState(false)
    const [modalShowUser, setModalShowUser] = useState(false)
    const [selectId, setSelectId] = useState([])
    const [useRowSelect, setUserSelect] = useState(null)
    const [part_id, setPart_Id] = useState();
    const [company_id, setCompany_Id] = useState();

    const handleSubmit = (e) => {
        e.preventDefault();
        let _param = ''
        if (part_id) _param += "&part_id=" + part_id
        if (company_id) _param += "&company_id=" + company_id
        setParam(_param);
    };
    const handleChange = (id) => {
        setSelectId((prevIds) => {
            if (prevIds.includes(id)) {
                return prevIds.filter((item) => item !== id);
            } else {
                return [...prevIds, id];
            }
        });
    };
    let columns = [
        {
            name: "id", label: "#",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <input type="checkbox" checked={selectId.includes(value)}
                        onChange={() => handleChange(value)} />
                },
            }
        },
        { name: "id", label: "ID" },
        { name: "fullname", label: "Họ tên" },
        { name: "code", label: "Mã nhân viên" },
        { name: "email", label: "Email" },
        { name: "department_name", label: "Phòng/Ban" },
        { name: "company_name", label: "Công ty" },
        {
            name: "code", label: "Thao tác",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <>
                        <button type="button" className="btn btn-sm btn-warning" onClick={() => {
                            setModalShow(true);
                            setDataSelect(tableMeta)
                        }}>Xem BCC</button>
                        <button type="button" className="btn btn-sm btn-success ml-2" onClick={() => {
                            setModalShowUser(true);
                            setUserSelect(tableMeta)
                        }}>Xem TT</button>
                    </>
                },
            }
        },
    ];

    let columnsBcc = [
        { name: "id", label: "ID", options: { filter: false, sort: true } },
        {
            name: "fullname", label: "Thông tin",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <div className="w-100" style={{ minWidth: 200 }}>
                        <small>Họ tên:</small> <strong>{value}</strong><br />
                        <small>MSNV:</small> <strong>{tableMeta.code}</strong><br />
                        <small>Chức vụ:</small> <strong>{tableMeta.chucvu}</strong><br />
                        <small>Phòng ban:</small> <strong>{tableMeta.part}</strong><br />
                        <small>Công ty:</small> <strong>{tableMeta.company}</strong><br />
                    </div>
                },
            }
        },
        {
            name: "time_checkin", label: "Chấm vào",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    let result = ''
                    if (tableMeta.checkin_status === 0) result = <span className="text-danger">Chưa chấm vào</span>
                    if (tableMeta.checkin_status === 1) result = <span className="text-success">Đúng giờ</span>
                    if (tableMeta.checkin_status === 2) result = <span className="text-warning">Vào muộn</span>
                    if (tableMeta.checkin_status === 3) result = <span className="text-success">Có phép</span>
                    if (tableMeta.checkin_status === 4) result = <span className="text-success">Đã giải trình</span>

                    return <div className="w-100">
                        <strong>{value}</strong><br />
                        {result}
                    </div>
                },
            }
        },
        {
            name: "time_checkout", label: "Chấm Ra",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    let result = ''
                    if (tableMeta.checkout_status === 0) result = <span className="text-danger">Chưa chấm ra</span>
                    if (tableMeta.checkout_status === 1) result = <span className="text-success">Đúng giờ</span>
                    if (tableMeta.checkout_status === 2) result = <span className="text-warning">Về sớm</span>
                    if (tableMeta.checkout_status === 3) result = <span className="text-success">Có phép</span>
                    if (tableMeta.checkout_status === 4) result = <span className="text-success">Đã giải trình</span>

                    return <div className="w-100">
                        <strong>{value}</strong><br />
                        {result}
                    </div>
                },
            }
        },
        { name: "text_status", label: "Trạng thái công" },
        { name: "point", label: "Công thực tế" },
        { name: "datecheck", label: "Ngày chấm công" },
    ];


    return (<AkkhorLayout idrole="list-parts">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>

                <li>Danh sách phòng ban</li>
            </ul>
        </div>
        <div className="card mb-3">
            <div className="card-header">
                <div className="d-flex" onClick={() => setFilterShow(!filterShow)}>
                    <div className="mr-auto">
                        <h3 className="title">Tìm kiếm</h3>
                    </div>
                    <button className="btn btn-sm btn-defaul"><span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
                </div>
            </div>
            <div className={filterShow ? "card-body" : 'hidden-filter'}>
                <form className="new-added-form" method="get" >
                    <div className="row">
                        <div className="col-sm-3 col-12 form-group">
                            <label>Công ty </label>
                            <SearchBoxModal apiname={"company"} placeholder="Chọn Công ty" colvalue={'id'} colname={'title'} name='company_id'
                                onChange={(e) => {
                                    setCompany_Id(e)
                                }}></SearchBoxModal>
                        </div>
                        <div className="col-sm-3 col-12 form-group">
                            <label>Phòng ban </label>
                            <SearchBoxModal apiname={"parts"} placeholder="Chọn phòng ban" colvalue={'id'} colname={'title'} name='part_id'
                                onChange={(e) => {
                                    setPart_Id(e)
                                }}></SearchBoxModal>
                        </div>

                        <div className="col-12 ">
                            <button type="submit" onClick={handleSubmit} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark">Lọc</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <SRList noAction={1} name="theodoinghi" idrole="users_leave" params={params} pagination={false} title="Nhân sự nghỉ nhiều" defaultLimit={50} serverSide={true} columns={columns} />

        <Modal show={modalShow} onHide={() => { setModalShow(false); setDataSelect(false) }} animation={true} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>{dataSelect && dataSelect.fullname}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="">
                {dataSelect && <SRList name="users_onday" idrole="users_onday" params={"&code=" + dataSelect.code} title="" defaultLimit={50} serverSide={true} columns={columnsBcc} />}
            </Modal.Body>
        </Modal>
        <Modal show={modalShowUser} onHide={() => { setModalShowUser(false)}} animation={true} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Thông tin nhân sự</Modal.Title>
            </Modal.Header>
            <Modal.Body className="">
                {useRowSelect && <FormUsersFast id={useRowSelect.id}/>}
            </Modal.Body>
        </Modal>
    </AkkhorLayout>);
}
